<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getSponserProgramTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionSponserProgram && permissionSponserProgram.permission_id === permission.readWrite"
          @click.native="createSponserData"/>
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header.id">
              {{ header.text }}
              <template v-if="header.icon">
                <a @click="sortDataTable">
                  <v-icon class="fas fa-caret-down"
                          v-if="sort_order == 'desc'"
                          style="font-size: 12px"></v-icon>
                  <v-icon class="fas fa-caret-up"
                          v-if="sort_order == 'asc'"
                          style="font-size: 12px"></v-icon>
                </a>
              </template>
            </th>
          </tr>
          </thead>
          <tr v-for="(item,index) in dataTable">
            <td width="5%" align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
            <td>{{item.branch ? item.branch.branch_name_en : ''}}</td>
            <td>{{item.title_en}}</td>
            <td>{{item.orders}}</td>
            <td>{{item.updated_at | moment('DD-MM-YYYY')}}</td>
            <td>
              <a @click="showSponserData(item.id)">
                <icon-pencil />
              </a>
            </td>
          </tr>
          <tbody>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
    import InputSearch from "../../../components/Input/InputSearch";
    import CircleButton from "../../../components/Button/CircleButton";
    import IconPencil from "../../../components/Icon/icon-pencil";
    import Paginate from "../../../components/Layout/Paginate";
    import {permissionSponserProgram, role} from "../../../util/Permission";
    import Loading from 'vue-loading-overlay';
    import Swal from "sweetalert";

    export default {
        name: "SponserProgramTable",
      components: {Paginate, IconPencil, CircleButton, InputSearch, Loading},
      computed:{
        permissionSponserProgram,
      },
      data() {
        return {
          title: "Sponser program",
          isLoading: false,
          headers: [
            { id: 1, text: "No.",icon : null },
            { id: 2, text: "Branch",icon : null },
            { id: 3, text: "Title",icon : null },
            { id: 4, text: "Order",icon : true },
            { id: 5, text: "Update date",icon : null },
            { id: 6, text: "Edit",icon : null }
          ],
          dataTable: [],
          dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
          },
          permission : null,
          search : '',
          sort_order : 'desc'
        };
      },
      created() {
        this.permission = role;
          this.getSponserProgramTable(1);
      },
      methods:{
        getSponserProgramTable(page){
          this.isLoading = true;
          this.$store.dispatch("SponserProgram/getSponserProgram",{
            page ,
            search : this.search,
            sort_order : this.sort_order,
          }).then(res=>{
            if(res.response_code == 200){
              this.dataTable = res.result.data;
              this.dataPaginate = {
                current_page: res.result.current_page,
                from: res.result.from,
                last_page: res.result.last_page,
                per_page: res.result.per_page,
                total: res.result.total,
                to: res.result.to
              }
            }
            this.isLoading = false;
          }).catch(()=>{
            Swal('','Cannot get Sponser program data','error');
            this.isLoading = false;
          });
        },
        async changePage(val){
          this.isLoading = true;
          this.dataPaginate.current_page = val;
          await this.getSponserProgramTable(this.dataPaginate.current_page);
          this.isLoading = false;
        },
        goToSponserEdit(){
          this.$router.push("/sponser-program/edit");
        },
        showSponserData(id){
          this.isLoading = true;
          this.$store.dispatch("SponserProgram/showSponserProgram",id).then(res=>{
            if(res.response_code == 200){
             this.$store.dispatch("SponserProgram/setFormSponserProgram",res.result).then(()=>{
               this.goToSponserEdit();
             })
            }
            this.isLoading = false;
          }).catch(()=>{
            Swal('','Cannot get Sponser program data','error');
            this.isLoading = false;
          });
        },
        createSponserData(){
          this.$store.dispatch("SponserProgram/clearFormData").then(()=>{
            this.goToSponserEdit();
          })
        },
        searchInput(val){
          this.search = val;
        },
        sortDataTable(){
          this.sort_order = this.sort_order == 'desc' ? 'asc' : 'desc';
          this.getSponserProgramTable(1);
        }
      }
    }
</script>

<style scoped>
  .branch-data {
    background-color: transparent;
    margin: 20px;
  }
</style>
